<template>
  <v-container>
    <v-row wrap align="center" justify="center">
      <v-col class="home">
        <v-row justify="center">
          <div class="title">Welcome to the Cabin</div>
        </v-row>
        <v-row justify="center" align="center">
          <router-link class="mr-4" :to="{ name: 'stories' }">Stories</router-link>
          <router-link class="mr-4" :to="{ name: 'birds' }">Birds</router-link>
          <router-link :to="{ name: 'plants' }">Plants</router-link>
        </v-row>
        <v-row justify="center" align="center">
          <v-card>
            <v-card-title>
              <v-spacer />
              <div>Cabin Inventory</div>
              <v-spacer />
            </v-card-title>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Item</th>
                    <th class="text-left">Qty</th>
                    <th class="text-center">Update</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in inventory" :key="item.id">
                    <td>{{ item.item }}</td>
                    <td>{{ item.qty }}</td>
                    <td class="text-right">
                      <v-btn icon @click="updateInventory(item.id, { ...item, qty: Number(item.qty) + 1 })">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="updateInventory(item.id, { ...item, qty: Number(item.qty) - 1 })">
                        <v-icon>mdi-minus-circle-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="deleteInventory(item.id)">
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td width="150">
                      <v-text-field dense hide-details outlined v-model="item" type="text" label="Item" />
                    </td>
                    <td width="100">
                      <v-text-field dense hide-details outlined v-model="qty" type="number" label="Qty" />
                    </td>
                    <td class="text-right">
                      <v-btn small outlined :disabled="!item" @click="addInventory">Add</v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { db } from '@/plugins/firebase'
import bus from '@/helpers/bus'

export default {
  data: () => ({
    inventory: [],
    item: null,
    qty: 0
  }),
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapActions(['handleFirebaseError']),
    async updateInventory(id, data) {
      try {
        await db.collection('inventory').doc(id).set(data)
      } catch(e) {
        this.handleFirebaseError(e)
        return Promise.reject(e)
      }
    },
    async deleteInventory(key) {
      try {
        db.collection('inventory').doc(key).delete()
        bus.$emit('snackbar', 'Inventory item deleted')
      } catch(e) {
        this.handleFirebaseError(e)
        return Promise.reject(e)
      }
    },
    async addInventory() {
      try {
        if (this.item && this.qty) {
          await db.collection('inventory').add({
            item: this.item,
            qty: this.qty
          })
          this.item = ''
          this.qty = 0
          bus.$emit('snackbar', 'Inventory item added')
        }
      } catch(e) {
        this.handleFirebaseError(e)
        return Promise.reject(e)
      }
    }
  },
  created() {
    db.collection('inventory').onSnapshot(snapshot => {
      let inventory = []
      snapshot.forEach(doc => {
        let item = {
          id: doc.id,
          ...doc.data()
        }
        inventory.push(item)
      })
      this.inventory = inventory
    })
  }
}
</script>